import { render } from "./insuPortal.vue?vue&type=template&id=2c46e9cc&scoped=true"
import script from "./insuPortal.vue?vue&type=script&lang=js"
export * from "./insuPortal.vue?vue&type=script&lang=js"

import "./insuPortal.vue?vue&type=style&index=0&id=2c46e9cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c46e9cc"]])

export default __exports__